<template>
    <ul :class='"list list-" + $parent.model'>

    <router-link tag='li' :to='$parent.getOpenLink(null, item.id)' v-for="item in $parent.items.data" :key='item.id' :class='"list-" + $parent.model + "_item"'>
        <!-- ID: {{item.id}}<br /> -->
        <!-- @updatehere -->
        <div>{{formatNameCompliant({forenames: item.p1_forenames, surname: item.p1_surname, user_title_id: item.p1_user_title_id})}} <template v-if='item.p1_gender || item.p1_dob'>(<template v-if='item.p1_gender'>{{item.p1_gender.toUpperCase()}}</template><template v-if='item.p1_dob'> {{item.p1_dob | getAge}}</template>)</template></div>
        <div><template v-if='item.p1_email'>{{item.p1_email}}</template><template v-else>[no email]</template></div>
        <div v-if="is_network_admin()">{{item.provider.name}}</div>
        <div style='text-align: center; font-size: 1rem'><strong>~</strong></div>
        <div>{{formatNameCompliant({forenames: item.p2_forenames, surname: item.p2_surname, user_title_id: item.p2_user_title_id})}} <template v-if='item.p2_gender || item.p2_dob'>(<template v-if='item.p2_gender'>{{item.p2_gender.toUpperCase()}}</template><template v-if='item.p2_dob'> {{item.p2_dob | getAge}}</template>)</template></div>
        <div><template v-if='item.p2_email'>{{item.p2_email}}</template><template v-else>[no email]</template></div>
        <div v-if="is_network_admin()">{{item.provider.name}}</div>
    </router-link>
    </ul>
</template>

<script>
    export default {
        props: [
        ],
        data: function() {
        return {
                    //	item: 'test'
                    };
        },
        methods: {
        }
    }
</script>
